import { useField } from 'formik'
import omit from 'lodash-es/omit'

import { EMPTY_LIST } from '../../../constants/common'

import { EmailRecipientsSelect } from './EmailRecipientsSelect'

function EmailRecipientsField({ name, onChange, ...props }) {
  const [field] = useField(name)

  const value = field.value || EMPTY_LIST

  const selectProps = omit(props, ['isLoading', 'loadInitialValue'])

  function handleChange(nextValue) {
    onChange?.(nextValue)
  }

  return (
    <EmailRecipientsSelect
      {...selectProps}
      name={name}
      value={value}
      onChange={handleChange}
    />
  )
}

export default EmailRecipientsField
